import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { I18nEffects } from 'app/core/store/admin/i18n/i18n.effects';
import { CalendarOrdersEffects } from 'app/core/store/calendar/orders/calendar-orders.effects';
import { CalendarRelocationsEffects } from 'app/core/store/calendar/relocations/calendar-relocations.effects';
import { SapInvoiceEffects } from './store/sap-invoice/sap-invoice.effects';
// import { CookieModule } from 'ngx-cookie';
import { appSettings } from 'app/appSettings';
import { Observable } from 'rxjs';

import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { I18Sandbox } from 'app/core/sandboxes/i18n.sandbox';
import { StockCountsEffects } from 'app/core/store/stock-count/stock-count.effects';
import { environment } from 'environments/environment';
import { CookieModule } from 'ngx-cookie';
import { AuthenticatorInterceptor } from './interceptors/authenticator.interceptor';
import { CustomerIdInterceptor } from './interceptors/customer-id.interceptor';
import { reducers } from './store';
import { OpenPdfEffect } from './store/_shared/open-pdf-effect';
import { AdminDefinitionsEffects } from './store/admin/admin-definitions/admin-definitions.effects';
import { UsersEffects } from './store/admin/users/users.effects';
import { AzureLogEffects } from './store/azure-log/azure-log.effects';
import { BlankReceiptsEffects } from './store/blank-receipts/blank-receipts.effects';
import { ConfigEffects } from './store/config/config.effects';
import { CustomerSummaryEffects } from './store/contract-details/customer-summary/customer-summary.effects';
import { CCRDetailEffects } from './store/edit-ccr-detail/ccr-detail.effects';
import { FlowDetailEffects } from './store/edit-flow-detail/flow-detail.effects';
import { RelocationDetailEffects } from './store/edit-relocation-detail/relocation-detail.effects';
import { EmailActorsEffects } from './store/email-actors/email-actors.effects';
import { FlowsEffects } from './store/flows/flows.effects';
import { OrderDetailEffects } from './store/order-detail/order-detail.effects';
import { OrdersEffects } from './store/orders/orders.effects';
import { RelocationsEffects } from './store/relocations/relocations.effects';
import { RouterEffects } from './store/router/router.effects';
import { ContactEffects } from './store/service/contact/contact.effects';
import { SelectCustomerEffects } from './store/session/selected-customer/select-customer.effects';
import { UserContextEffects } from './store/session/user-context/user-context.effects';
import { StockEffects } from './store/stock/stock.effects';
import { TemplateEffects } from './store/template/template.effects';

export function createTranslateLoader(httpClient: HttpClient, i18nSandbox: I18Sandbox) {
  const translateLoader: TranslateLoader = {
    getTranslation(lang: string): Observable<any> {
      if (lang === appSettings.DEFAULT_LANGUAGE) {
        return i18nSandbox.referenceJson$();
      } else {
        return i18nSandbox.json$(lang);
      }
    },
  };
  return translateLoader;
}

const effects = [
  OrdersEffects,
  FlowsEffects,
  TemplateEffects,
  OrderDetailEffects,
  FlowDetailEffects,
  CCRDetailEffects,
  UserContextEffects,
  AzureLogEffects,
  AdminDefinitionsEffects,
  UsersEffects,
  SelectCustomerEffects,
  CalendarOrdersEffects,
  CalendarRelocationsEffects,
  StockEffects,
  EmailActorsEffects,
  BlankReceiptsEffects,
  ContactEffects,
  I18nEffects,
  RelocationsEffects,
  RelocationDetailEffects,
  RouterEffects,
  OpenPdfEffect,
  CustomerSummaryEffects,
  ConfigEffects,
  SapInvoiceEffects,
  StockCountsEffects,
];

@NgModule({
  imports: [
    CookieModule.withOptions(),
    /**
     * StoreModule.provideStore is imported once in the root module, accepting a reducer
     * function or object map of reducer functions. If passed an object of
     * reducers, combineReducers will be run creating your application
     * meta-reducer. This returns all providers for an @ngrx/store
     * based application.
     */
    StoreModule.forRoot(reducers),
    // StoreDevtoolsModule.instrument({ maxAge: 60 }),
    ...(environment.production ? [] : [StoreDevtoolsModule.instrument({ maxAge: 60 , connectInZone: true})]),
    RouterModule.forRoot([
      /* routes */
    ]),
    EffectsModule.forRoot(effects),
    StoreRouterConnectingModule.forRoot(),

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, I18Sandbox],
      },
    }),
  ],
  exports: [TranslateModule],
  declarations: [],
  providers: [

    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticatorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomerIdInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {
}
